import { connect } from 'react-redux'
import { fromPro } from 'store/selectors'
import { proAuthLogout } from 'store/actions'
import injectTranslate from 'i18n/hoc/injectTranslate'
import HeaderSection from './HeaderSection'

const mapStateToProps = state => ({
  isLoggedIn: fromPro.isLoggedIn(state),
})

const mapDispatchToProps = dispatch => ({
  proLogout: () => dispatch(proAuthLogout()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectTranslate(HeaderSection))
